import React, { useEffect, useState } from 'react';
import { CButton, CCard, CCardHeader, CCol, CRow } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { getAll } from 'src/services/AccountTransactions';
import { DataGrid } from '@mui/x-data-grid';
import formatter from 'src/reusables/formatter';

function AccountTransactions() {
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);

  const navigate = useNavigate();

  async function fetchMainData() {
    const res = await getAll();
    const rows =
      res.trxs &&
      res.trxs.map((item, i) => {
        return {
          no: i + 1,
          id: item.id,
          accountName: item.accountName,
          coaID: item.coa_id,
          bankName: item.bankName,
          cabID: item.cab_id,
          notes: item.notes,
          categoryName: item.categoryName,
          categoryID: item.category_id,
          imageURL: item.image_url,
          notes: item.notes,
          amount: item.amount
          // balance: formatter('currency', item?.balance ?? 0)
        };
      });

    setDataRows(rows);

    const columns = [
      { field: 'no', headerName: 'No', width:'200' },
      { field: 'accountName', headerName: 'Account Name', width:'200' },
      { field: 'bankName', headerName: 'Bank Name', width:'200' },
      { field: 'categoryName', headerName: 'Category', width:'200' },
      { field: 'amount', headerName: 'Amount', width:'200' }
      // { field: 'balance', headerName: 'Balance' }
    ];

    setDataColumns(columns);
  }

  useEffect(() => {
    fetchMainData();
  }, []);

  function handleRowClick(params) {
    navigate('/account-transaction-actions', { state: params.row });
  }

  return (
    <div style={{ color: 'black' }}>
      <CCard>
        <CCardHeader>Accounts Transactions</CCardHeader>
        <div style={{ margin: '16px' }}>
          <CRow className="mb-3">
            <CCol xs={9} lg={9}></CCol>
            <CCol xs={3} lg={3} style={{ textAlign: 'right' }}>
              <CButton
                style={{ borderColor: 'primary' }}
                onClick={() => {
                  navigate('/account-transaction-actions');
                }}
              >
                Create
              </CButton>
              &nbsp;
              <CButton
                style={{ backgroundColor: 'white', color: 'black' }}
                onClick={() => {
                  navigate('/account-transaction-actions');
                }}
              >
                Download
              </CButton>
            </CCol>
          </CRow>
          <DataGrid
            rows={dataRows}
            columns={dataColumns}
            onRowClick={handleRowClick}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 }
              }
            }}
            pageSizeOptions={[5, 10, 20, 25]}
            style={{ textAlign: 'center' }}
          />
        </div>
      </CCard>
    </div>
  );
}

export default AccountTransactions;
